import { render, staticRenderFns } from "./BookingContentStatusCancelled.vue?vue&type=template&id=978d07bc&"
import script from "./BookingContentStatusCancelled.vue?vue&type=script&lang=js&"
export * from "./BookingContentStatusCancelled.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports